import {
  cancelRequest,
  createRequest,
  fetchRequests,
  fetchSupplies
} from '../api/system'

function normalizeSupplyRecord(record) {
  const warningNum = Number(record.warningNum ?? record.warning_num ?? 0)
  const stock = Number(record.stock ?? 0)

  return {
    ...record,
    warningNum,
    warning: warningNum > stock
  }
}

function normalizePagedData(data) {
  return {
    ...data,
    list: data?.list || data?.content || [],
    content: data?.content || data?.list || [],
    total: data?.total ?? data?.totalElements ?? 0,
    totalElements: data?.totalElements ?? data?.total ?? 0
  }
}

function normalizeRequestRecord(record) {
  const applyStatus = Number(record.applyStatus ?? 0)
  let supplies = record.suppliesJson || record.supplies_json || {}
  let user = record.userJson || record.user_json || {}

  if (typeof supplies === 'string') {
    try {
      supplies = JSON.parse(supplies)
    } catch (error) {
      supplies = {}
    }
  }

  if (typeof user === 'string') {
    try {
      user = JSON.parse(user)
    } catch (error) {
      user = {}
    }
  }

  return {
    ...record,
    applyStatus,
    createTime: record.createTime || record.create_time || '',
    rejectReason: record.rejectReason || record.reject_reason || '',
    suppliesName: supplies?.name || record.suppliesName || record.supplies_name || '',
    userUsername: user?.username || record.userUsername || record.username || ''
  }
}

async function fetchEmployeeSupplies(filters) {
  const response = await fetchSupplies(filters.page, filters.pageSize, {
    name: filters.search
  })

  return {
    ...response,
    data: {
      ...response.data,
      list: (response.data?.list || []).map(normalizeSupplyRecord),
      content: (response.data?.content || []).map(normalizeSupplyRecord)
    }
  }
}

function createEmployeeRequest(suppliesId, quantity, reason) {
  return createRequest({
    suppliesId: suppliesId,
    quantity,
    reason
  })
}

async function fetchEmployeeRequests(filters) {
  const response = await fetchRequests(filters.page, filters.pageSize, {})

  return {
    ...response,
    data: {
      ...normalizePagedData(response.data),
      list: (response.data?.list || response.data?.content || []).map(normalizeRequestRecord),
      content: (response.data?.content || response.data?.list || []).map(normalizeRequestRecord)
    }
  }
}

function cancelEmployeeRequest(requestId) {
  return cancelRequest({
    id: requestId
  })
}

export {
  cancelEmployeeRequest,
  createEmployeeRequest,
  fetchEmployeeRequests,
  fetchEmployeeSupplies
}
